import * as React from "react";

interface EditableSectionFormProps {
    children?: React.ReactNode;
}

class EditableSectionForm extends React.Component<EditableSectionFormProps> {
    render() {
        return this.props.children || null;
    }
}

export default EditableSectionForm;